import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Spin } from 'antd';
import PropTypes from 'prop-types';
import PropTypesImmutable from 'react-immutable-proptypes';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import {
  goToTransferring,
  goToCancelingCertificates,
  goToExporting,
  goToCancelingEecsGOs,
} from '../../utils/gotoLink';
import { AccountTable } from '../../components';
import * as actions from '../../actions/actionCreators/accountActionCreators';
import {
  getUserLegalEntity,
  getUserLegalEntityAccounts,
} from '../../reducers/userReducer';
import {
  getOverviewList,
  getOverviewListData,
  getGroupedCertificates,
  getEecsListData,
  getEecsTotal,
} from '../../reducers/accountOverviewReducer';
import { formAccountOverviewFilter } from '../../constants/forms/formAccountOverviewFilter';
import gasType from '../../constants/classificators/gasType';
import { setEecsGoRows } from '../../actions/actionCreators/accountActionCreators';

export class AccountSummary extends Component {
  static propTypes = {
    isLoading: PropTypes.bool.isRequired,
    t: PropTypes.func.isRequired,
    fetchGroupedCertificatesAndTransfer: PropTypes.func.isRequired,
    fetchGroupedCertificatesAndCancel: PropTypes.func.isRequired,
    fetchGroupedCertificatesAndExport: PropTypes.func.isRequired,
    fetchEecsAccountOverview: PropTypes.func.isRequired,
    fetchEecsAccountTotal: PropTypes.func.isRequired,
    fetchAllEecsGOsForAccount: PropTypes.func.isRequired,
    dataList: PropTypesImmutable.list.isRequired,
    eecsDataList: PropTypesImmutable.map,
    accountIds: PropTypes.array,
    eecsTotal: PropTypes.number,
    eecsCode: PropTypes.string,
  };

  state = {
    eecsLoading: false,
  };

  render() {
    const {
      isLoading,
      t,
      dataList,
      fetchGroupedCertificatesAndTransfer,
      fetchGroupedCertificatesAndCancel,
      fetchGroupedCertificatesAndExport,
      fetchEecsAccountOverview,
      fetchEecsAccountTotal,
      fetchAllEecsGOsForAccount,
      accountIds,
      userAccounts,
      manufacture,
      fieldsIncludes,
      legalEntity,
      eecsDataList,
      eecsTotal,
      eecsCode,
    } = this.props;

    // Add total quantity as the last element of json
    let data = dataList.toJS();
    let eecsData = eecsDataList?.toJS();
    if (data.length > 0) {
      let biomethaneTotalQuantity = data
        .filter((row) => row.gasType === gasType.BIOMETHANE_GAS_TYPE)
        .map((row) => row.quantity)
        .reduce((acc, amount) => acc + amount, 0);
      let hydrogenTotalQuantity = data
        .filter((row) => row.gasType === gasType.HYDROGEN_GAS_TYPE)
        .map((row) => row.quantity)
        .reduce((acc, amount) => acc + amount, 0);

      data.push({
        biomethaneQuantity: biomethaneTotalQuantity,
        hydrogenQuantity: hydrogenTotalQuantity,
        summary: true,
      });
    }

    return (
      <Spin spinning={isLoading || this.state.eecsLoading}>
        <AccountTable
          t={t}
          eecsLoading={this.state.eecsLoading}
          setEecsLoading={(value) => this.setState({ eecsLoading: value })}
          legalEntity={legalEntity}
          accountIds={accountIds}
          dataList={data}
          eecsDataList={eecsData}
          eecsTotal={eecsTotal}
          transferCertificates={fetchGroupedCertificatesAndTransfer}
          exportCertificates={fetchGroupedCertificatesAndExport}
          cancelCertificates={fetchGroupedCertificatesAndCancel}
          userAccounts={userAccounts}
          manufacture={manufacture}
          fieldsIncludes={fieldsIncludes}
          fetchEecsAccountOverview={fetchEecsAccountOverview}
          fetchEecsAccountTotal={fetchEecsAccountTotal}
          fetchAllEecsGOsForAccount={fetchAllEecsGOsForAccount}
          eecsCode={eecsCode}
        />
      </Spin>
    );
  }
}

const getLoading = getLoadingSelector(getOverviewList, getGroupedCertificates);

const mapStateToProps = (state) => ({
  isLoading: getLoading(state),
  dataList: getOverviewListData(state),
  eecsDataList: getEecsListData(state),
  eecsTotal: getEecsTotal(state),
  userAccounts: getUserLegalEntityAccounts(state),
  legalEntity: getUserLegalEntity(state),
  info: state,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  fetchGroupedCertificatesAndTransfer: async (eGoRows, eecsGoRows) => {
    const sortedRows = [...eecsGoRows].sort((a, b) => a.id - b.id);
    dispatch(setEecsGoRows(sortedRows));
    await dispatch(
      actions.fetchGroupedCertificates({
        [formAccountOverviewFilter.SELECTED_ROWS]: eGoRows,
        [formAccountOverviewFilter.ACCOUNT_IDS]: ownProps.accountIds,
      })
    );
    goToTransferring(ownProps.accountIds);
  },
  fetchGroupedCertificatesAndExport: async (rows, eecsGoRows) => {
    const sortedRows = [...eecsGoRows].sort((a, b) => a.id - b.id);
    dispatch(setEecsGoRows(sortedRows));
    await dispatch(
      actions.fetchGroupedCertificates({
        [formAccountOverviewFilter.SELECTED_ROWS]: rows,
        [formAccountOverviewFilter.ACCOUNT_IDS]: ownProps.accountIds,
      })
    );
    goToExporting(ownProps.accountIds);
  },
  fetchGroupedCertificatesAndCancel: async (eGoRows, eecsGoRows) => {
    if (eGoRows.length > 0) {
      await dispatch(
        actions.fetchCancelGroupedCertificates({
          [formAccountOverviewFilter.SELECTED_ROWS]: eGoRows,
          [formAccountOverviewFilter.ACCOUNT_IDS]: ownProps.accountIds,
        })
      );
      goToCancelingCertificates(ownProps.accountIds);
    } else {
      const sortedRows = [...eecsGoRows].sort((a, b) => a.id - b.id);
      dispatch(setEecsGoRows(sortedRows));
      goToCancelingEecsGOs(ownProps.accountIds);
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(AccountSummary);
